function Contact () {
    return (
        <section className="row justify-content-center m-3">
        <h2 className="col-12 d-flex justify-content-center m-3">Contact Me</h2>
        <div className="col-12 d-flex justify-content-center m-3">jschermann91@gmail.com</div>
        <div className="col-12 d-flex justify-content-center m-1">218-232-7669</div>
      </section>
    )
}

export default Contact;